<template>
  <header class="header" :class="{ 'header-scrolled': isScrolled }">
    <div class="header-container">
      <div class="logo" @click="navigate('/')">
        <!-- <img src="../static/home/logo.png" alt="logo" /> -->
      </div>
      <nav class="nav">
        <ul class="nav-list">
          <li class="nav-item">
            <a class="nav-link" @click.prevent="navigate('/')">首页</a>
          </li>
          <li class="nav-item" @mouseenter="showAboutDropdown = !isMobile" @mouseleave="showAboutDropdown = false">
            <a class="nav-link" @click.prevent="navigate('/about')">
              <span class="nav-link-txt">关于</span>
              <span class="nav-link-txt">星翰</span>
            </a>
            <div v-show="showAboutDropdown" class="dropdown-menu-wrapper">
              <ul class="dropdown-menu">
                <li><a @click.prevent="navigate('/about')">公司简介</a></li>
                <li><a @click.prevent="navigate('/about', '#culture')">企业文化</a></li>
                <li><a @click.prevent="navigate('/about', '#cooperation')">合作共赢</a></li>
                <li><a @click.prevent="navigate('/about', '#honors')">资质荣誉</a></li>
                <li><a @click.prevent="navigate('/about', '#history')">发展历程</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item" @mouseenter="showRDDropdown = !isMobile" @mouseleave="showRDDropdown = false">
            <a class="nav-link" @click.prevent="navigate('/rd')">
              <span class="nav-link-txt">科研</span>
              <span class="nav-link-txt">实力</span>
            </a>
            <div v-show="showRDDropdown" class="dropdown-menu-wrapper">
              <ul class="dropdown-menu">
                <li><a @click.prevent="navigate('/rd')">实验与设备</a></li>
                <li><a @click.prevent="navigate('/rd', '#cooperation-rd')">产学研合作</a></li>
                <li><a @click.prevent="navigate('/rd', '#patents')">专利与认证</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item" @mouseenter="showSolutionsDropdown = !isMobile"" @mouseleave="
            showSolutionsDropdown = false">
            <a class="nav-link" @click.prevent="navigate('/solutions')">
              <span class="nav-link-txt">解决</span>
              <span class="nav-link-txt">方案</span>
            </a>
            <div v-show="showSolutionsDropdown" class="dropdown-menu-wrapper">
              <ul class="dropdown-menu">
                <li><a @click.prevent="navigate('/solutions?type=guangfu')">光伏新能源</a></li>
                <li><a @click.prevent="navigate('/solutions?type=bandaoti')">泛半导体</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item" @mouseenter="showNewsDropdown = !isMobile"" @mouseleave=" showNewsDropdown = false">
            <a class="nav-link" @click.prevent="navigate('/news')">
              <span class="nav-link-txt">新闻</span>
              <span class="nav-link-txt">动态</span>
            </a>
            <div v-show="showNewsDropdown" class="dropdown-menu-wrapper">
              <ul class="dropdown-menu">
                <li><a @click.prevent="navigate('/news?type=gongsi')">公司动态</a></li>
                <li><a @click.prevent="navigate('/news?type=hangye')">行业资讯</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item" @mouseenter="showRecruitmentDropdown = !isMobile""
            @mouseleave=" showRecruitmentDropdown = false">
            <a class="nav-link" @click.prevent="navigate('/jobs')">
              <span class="nav-link-txt">招贤</span>
              <span class="nav-link-txt">纳士</span>
            </a>
            <div v-show="showRecruitmentDropdown" class="dropdown-menu-wrapper">
              <ul class="dropdown-menu">
                <li><a @click.prevent="navigate('/jobs')">公司概况</a></li>
                <li><a @click.prevent="navigate('/jobs', '#good')">优势福利</a></li>
                <li><a @click.prevent="navigate('/jobs', '#life')">工作生活</a></li>
                <li><a @click.prevent="navigate('/jobs', '#job')">招聘职位</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item" @mouseenter="showContactDropdown = !isMobile"" @mouseleave=" showContactDropdown = false">
            <a class="nav-link" @click.prevent="navigate('/contact')">
              <span class="nav-link-txt">联系</span>
              <span class="nav-link-txt">我们</span>
            </a>
            <!-- <div v-show="showContactDropdown" class="dropdown-menu-wrapper">
              <ul class="dropdown-menu">
                <li>
                  <a @click.prevent="navigate('/contact', '#suzhou')">苏州公司</a>
                </li>
                <li>
                  <a @click.prevent="navigate('/contact', '#jiyuan')">济源公司</a>
                </li>
              </ul>
            </div> -->
          </li>
        </ul>
      </nav>
    </div>

    <div class="header-container-mobile">
      <div class="toogle_icon" @click="showDialog = true"></div>
      <div class="logo" @click="navigate('/')"></div>
      <div class="placeholder"></div>
    </div>

    <div class="dialog" v-show="showDialog">
      <img class="close_icon" src="../static/home/close.png" alt="" @click="showDialog = false">
      <nav class="nav">
        <ul class="nav-list">
          <li class="nav-item">
            <a class="nav-link" @click.prevent="navigate('/')">首页</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" @click.prevent="showAboutDropdown = !showAboutDropdown" :class="{active: showAboutDropdown}">
              <span class="nav-link-txt">关于星翰</span>
              <img src="../static//home/arrow.png" alt="">
            </a>
            <div class="dropdown-menu-wrapper" v-show="showAboutDropdown">
              <ul class="dropdown-menu">
                <li><a @click.prevent="navigate('/about')">公司简介</a></li>
                <li><a @click.prevent="navigate('/about', '#culture')">企业文化</a></li>
                <li><a @click.prevent="navigate('/about', '#cooperation')">合作共赢</a></li>
                <li><a @click.prevent="navigate('/about', '#honors')">资质荣誉</a></li>
                <li><a @click.prevent="navigate('/about', '#history')">发展历程</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link"  @click.prevent="showRDDropdown = !showRDDropdown" :class="{active: showRDDropdown}">
              <span class="nav-link-txt">科研实力</span>
              <img src="../static//home/arrow.png" alt="">
            </a>
            <div class="dropdown-menu-wrapper" v-show="showRDDropdown">
              <ul class="dropdown-menu">
                <li><a @click.prevent="navigate('/rd')">实验与设备</a></li>
                <li><a @click.prevent="navigate('/rd', '#cooperation-rd')">产学研合作</a></li>
                <li><a @click.prevent="navigate('/rd', '#patents')">专利与认证</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link"  @click.prevent="showSolutionsDropdown = !showSolutionsDropdown" :class="{active: showSolutionsDropdown}">
              <span class="nav-link-txt">解决方案</span>
              <img src="../static//home/arrow.png" alt="">
            </a>
            <div class="dropdown-menu-wrapper" v-show="showSolutionsDropdown">
              <ul class="dropdown-menu">
                <li><a @click.prevent="navigate('/solutions?type=guangfu')">光伏新能源</a></li>
                <li><a @click.prevent="navigate('/solutions?type=bandaoti')">泛半导体</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link" @click.prevent="showNewsDropdown = !showNewsDropdown" :class="{active: showNewsDropdown}">
              <span class="nav-link-txt">新闻动态</span>
              <img src="../static//home/arrow.png" alt="">
            </a>
            <div class="dropdown-menu-wrapper" v-show="showNewsDropdown">
              <ul class="dropdown-menu">
                <li><a @click.prevent="navigate('/news?type=gongsi')">公司动态</a></li>
                <li><a @click.prevent="navigate('/news?type=hangye')">行业资讯</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link" @click.prevent="showRecruitmentDropdown = !showRecruitmentDropdown" :class="{ 'active': showRecruitmentDropdown }">
              <span class="nav-link-txt">招贤纳士</span>
              <img src="../static//home/arrow.png" alt="">
            </a>
            <div class="dropdown-menu-wrapper" v-show="showRecruitmentDropdown">
              <ul class="dropdown-menu">
                <li><a @click.prevent="navigate('/jobs')">公司概况</a></li>
                <li><a @click.prevent="navigate('/jobs', '#good')">优势福利</a></li>
                <li><a @click.prevent="navigate('/jobs', '#life')">工作生活</a></li>
                <li><a @click.prevent="navigate('/jobs', '#job')">招聘职位</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link" @click.prevent="navigate('/contact')">
              <span class="nav-link-txt">联系我们</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>

  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      isScrolled: false,
      showAboutDropdown: false,
      showRDDropdown: false,
      showSolutionsDropdown: false,
      showNewsDropdown: false,
      showRecruitmentDropdown: false,
      showContactDropdown: false,

      showDialog: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    isMobile() {
      return window.innerWidth < 768;
    },
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
    closeAllDropdowns() {
      this.showAboutDropdown = false
      this.showRDDropdown = false
      this.showSolutionsDropdown = false
      this.showNewsDropdown = false
      this.showRecruitmentDropdown = false
      this.showContactDropdown = false
    },
    navigate(path, hash = "") {
      this.showDialog = false
      this.closeAllDropdowns()
      // 如果当前路径与目标路径不同，则进行跳转
      if (this.$route.fullPath !== path && this.$route.path !== path ) {
        this.$router.push({ path, hash });
      }
      // 如果是当前页面但hash不同，则允许锚点跳转
      else if (this.$route.hash !== hash) {
        // 直接修改URL的hash部分以跳转到指定位置
        this.$router.push({ path, hash });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header-scrolled {
  background: #fff !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  .header-container {
    .logo {
      background: url('../static/home/logoColor.png') transparent no-repeat center top ~ "/ 100% 100%";
    }
  }

  .nav-link {
    color: #000000 !important;
  }

  .nav-link:hover {
    color: #0248FF !important;
  }
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0);
  // backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.header-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;

  .logo {
    margin-right: 67px;
    cursor: pointer;
    width: 225px;
    height: 37px;
    background: url('../static/home/logo.png') transparent no-repeat center top ~ "/ 100% 100%";
    // img{
    //   width: 225px;
    //   height: 37px;
    // }
  }

  .nav {
    .nav-list {
      display: flex;
      align-items: center;
      gap: 67px;
      list-style: none;

      .nav-item {
        position: relative;

        .nav-link {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          // gap: 5px;
          color: #fff;
          font-size: 16px;
          text-decoration: none;
          transition: color 0.3s ease;
          cursor: pointer;

          .nav-link-txt {
            white-space: nowrap;
          }
        }

        .nav-link:hover {
          transform: scale(1.1);
        }
      }
    }
  }

  .dropdown-menu-wrapper {
    padding-top: 20px;
    position: absolute;
    top: 100%;
    left: 0;

    .dropdown-menu {
      font-size: 14px;
      background: #fff;
      min-width: 160px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      padding: 8px 0;
      list-style: none;
      animation: fadeInDown 0.3s ease;

      li {
        padding: 0;

        a {
          display: block;
          padding: 10px 20px;
          color: #747474;
          text-decoration: none;
          transition: background-color 0.3s ease;
          cursor: pointer;
        }

        a:hover {
          background-color: #f5f7fa;
          color: #000;
        }
      }
    }
  }
}




@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.header-container-mobile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 55px;
  background: #fff;
  padding: 0 24px;


  .toogle_icon {
    width: 17px;
    height: 10px;
    background: url("../static/home/fold.png") transparent no-repeat center top ~"/ 100% 100%";
  }

  .logo {
    width: 112px;
    height: 19px;
    background: url("../static/home/logoColor.png") transparent no-repeat center top ~"/ 100% 100%";
  }
}

.dialog {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);

  .close_icon {
    position: absolute;
    right: 24px;
    top: 24px;
    width: 13px;
    height: 13px;
  }

  .nav {
    .nav-list {
      display: flex;
      align-items: center;
      gap: 67px;
      list-style: none;

      .nav-item {
        position: relative;

        .nav-link {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          // gap: 5px;
          color: #fff;
          font-size: 16px;
          text-decoration: none;
          transition: color 0.3s ease;
          cursor: pointer;

          .nav-link-txt {
            white-space: nowrap;
          }
        }
      }
    }
  }

  .dropdown-menu-wrapper {
    padding-top: 20px;
    position: absolute;
    top: 100%;
    left: 0;

    .dropdown-menu {
      font-size: 14px;
      background: #fff;
      min-width: 160px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      padding: 8px 0;
      list-style: none;
      animation: fadeInDown 0.3s ease;

      li {
        padding: 0;

        a {
          display: block;
          padding: 10px 20px;
          color: #747474;
          text-decoration: none;
          transition: background-color 0.3s ease;
          cursor: pointer;
        }
      }
    }
  }

  .nav {
    overflow: auto;
    padding-top: 55px;
    width: 80%;
    height: 100vh;
    background: #fff;

    .nav-list {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0;
      text-align: left;

      .nav-item {
        width: 100%;
        padding: 0 24px;

        .nav-link {
          padding: 15px 0;
          color: #676767;
          justify-content: space-between;

          img {
            width: 5px;
            height: 10px;
          }
        }

        .active {
          img {
            transform: rotate(90deg);
          }
        }

        .dropdown-menu-wrapper {
          width: 100%;
          position: relative;

          padding-top: 0;

          .dropdown-menu {
            background: #F6F6F6;
            border-radius: 8px;
            box-shadow: none;
          }
        }
      }
    }

  }
}

// pc
@media (min-width: 751px) {
  .header-container {
    display: flex;
  }

  .header-container-mobile {
    display: none;
  }
}

// mobile
@media (max-width: 750px) {
  .header-container {
    display: none;
  }

  .header-container-mobile {
    display: flex;
  }
}
</style>
